module.exports = __webpack_public_path__ + "img/svg/google-play-button.d1b1f03bb71961a0d3701610215145ab.svg";